
export const replaceStrArr = (text: string, replaceStrArr: string[], replaceTo: string) => {
    let normalizedKey: string = text;
    replaceStrArr.forEach(type => { 
      normalizedKey = normalizedKey.replace(`-${type}`, replaceTo);
    });
    return normalizedKey;
  };
  